export default "__VITE_ASSET__CeTEbgnA__"